import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';

@Injectable({
  providedIn: 'root',
})

export class TokenService {

    constructor (
        private http: HttpClient
    ) {}

    userTokens(): Observable<any> {
        return this.http
        .get<any>(`${environment.apiUrl}/v2/tokens/user-token`, { context: new HttpContext().set(BEARER_ONLY, true) });
    }

    tokenForSale(): Observable<any> {
        return this.http
        .get<any>(`${environment.apiUrl}/v2/tokens/for-sale?type=token`, { context: new HttpContext().set(BEARER_ONLY, true) });
    }

    checkOrderStatus(referenceId): Observable<any> {
        return this.http
        .post<any>(`${environment.apiUrl}/v2/tokens/check-status`,  {reference_id: referenceId}, { context: new HttpContext().set(BEARER_ONLY, true) });
    }

    userTokenOrderHistory(): Observable<any> {
        return this.http
        .get<any>(`${environment.apiUrl}/v2/tokens/order-history`, { context: new HttpContext().set(BEARER_ONLY, true) });
    }
}